import React, {Component} from 'react';

import SlickSlider from "react-slick";

import Image from '../Image'

import './Slider.scss';

export default class Slider extends Component {

    render() {
        const {images} = this.props;

        const settings = {
            arrows: false,
            dots: false,
            infinite: true,
            speed: 300,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        const imagesHTML = this.buildImages(images);

        return (
            <div className="Slider">
                <div className="Slider__vertical-spacer"/>
                <div className="Slider__Carousel">
                    <SlickSlider ref={c => this.slider = c } {...settings}>
                        {imagesHTML}
                    </SlickSlider>

                    <div className='Slider__ControlArrow Slider__ControlArrow--left' onClick={this.previous.bind(this)}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className='Slider__ControlArrow Slider__ControlArrow--right' onClick={this.next.bind(this)}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="Slider__vertical-spacer"/>
            </div>
        )
    }

    next() {
        this.slider.slickNext()
    }
    previous() {
        this.slider.slickPrev()
    }

    buildImages(images) {
        return images.map((image, index) => {
            return (
                <div key={index}>
                    <Image image={image}/>
                </div>
            );
        });
    }

}



// WEBPACK FOOTER //
// ./src/components/DetailPage/Slider/index.js